import React from "react";
import style from "./debridement.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { signedLockedAccess } from "../../../../utils";

export const DebridementViewMode = ({
  resp,
  listOptionsresp,
  assessmentDetails,
  hideButtons,
  noDataMsg,
  debridementperformedbyOptions,
  nonexcisionalapproachOptions,
  surgicaldebridementprocedureOptions,
  depthofdebridementOptions,
  instrumentsusedOptions,
  necroticsubcutaneoustissueOptions,
  necrotictissueOptions,
  notapplicableOptions,
  postdebridementbleedingamountOptions,
  techniqueusedOptions,
  onEdit,
  isReadOnly,
}) => (
  <div className={style.viewMode_container}>
    <div className="d-flex justify-content-between w-100">
      <div className={`${style.lab_container} w-100`}>
        {resp?.isDebridementPerformed && (
          <div className="pb-3">
            <label className="col-5 m-0">Was There Sharp/Surgical Debridement Performed: </label>
            <span className="col-7 p-0 font-weight-bold">{resp?.isDebridementPerformed === "no" ? "No" : "Yes"}</span>
          </div>
        )}

        {resp?.isDebridementPerformed === "yes" && (
          <div>
            {/* Performed By */}
            <div className="pb-3 row pl-3">
              <label className="col-5 m-0">Sharp/Surgical Debridement Performed By: </label>
              <span className="col-7 p-0 font-weight-bold">
                {debridementperformedbyOptions?.length > 0 &&
                  debridementperformedbyOptions.map((e) => {
                    const optionsValue = resp?.debridementPerformedBy === e.key ? e.value : "";
                    return (
                      <div className="font-weight-bold" key={e.key}>
                        {optionsValue}
                      </div>
                    );
                  })}
              </span>
            </div>

            {/* Surgical Procedure */}
            <div className="pb-3 row pl-3">
              <label className="col-5 m-0">Type of Sharp/Surgical Debridement Procedure: </label>
              <span className="col-7 p-0 font-weight-bold">
                {surgicaldebridementprocedureOptions?.length > 0 &&
                  surgicaldebridementprocedureOptions.map((e) => {
                    const optionsValue = resp?.surgicalDebridementProcedure === e.key ? e.value : "";
                    return (
                      <div className="font-weight-bold" key={e.key}>
                        {optionsValue}
                      </div>
                    );
                  })}
              </span>
            </div>

            {/* Non-Excisional Approach */}
            {resp?.nonExcisionalApproach !== "" && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Non-Excisional Approach: </label>
                <div className="col-7 p-0 font-weight-bold">
                  {nonexcisionalapproachOptions?.length > 0 &&
                    nonexcisionalapproachOptions.map((e) => {
                      const optionsValue = resp?.nonExcisionalApproach === e.key ? e.value : "";
                      return (
                        <div className="font-weight-bold" key={e.key}>
                          {optionsValue}
                        </div>
                      );
                    })}
                </div>
              </div>
            )}

            {/* Depth of Debridement */}
            {resp?.depthOfDebridement !== "" && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Depth of Debridement - Deepest Level: </label>
                <span className="col-7 p-0 font-weight-bold">
                  {depthofdebridementOptions?.length > 0 &&
                    depthofdebridementOptions.map((e) => {
                      const optionsValue = resp?.depthOfDebridement === e.key ? e.value : "";
                      return (
                        <div className="font-weight-bold" key={e.key}>
                          {optionsValue}
                        </div>
                      );
                    })}
                </span>
              </div>
            )}

            {/* Necrotic Subcutaneous Tissue */}
            {resp?.necroticSubcutaneousTissue?.length !== 0 && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Necrotic Subcutaneous Tissue: </label>
                <div className="col-7 p-0 font-weight-bold">
                  {resp?.necroticSubcutaneousTissue?.map((k) => {
                    let optionValue = "";
                    necroticsubcutaneoustissueOptions?.length > 0 &&
                      necroticsubcutaneoustissueOptions.map((l) => {
                        if (k == l.key) optionValue = l.value;
                      });
                    return (
                      <div className="font-weight-bold" key={k}>
                        {optionValue}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Necrotic Tissue */}
            {Array.isArray(resp?.necroticTissue) && resp?.necroticTissue?.length !== 0 && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Necrotic Tissue: </label>
                <div className="col-7 p-0 font-weight-bold">
                  {resp?.necroticTissue?.map((k) => {
                    let optionValue = "";
                    necrotictissueOptions?.length > 0 &&
                      necrotictissueOptions.map((l) => {
                        if (k == l.key) optionValue = l.value;
                      });
                    return (
                      <div className="font-weight-bold" key={k}>
                        {optionValue}
                      </div>
                    );
                  })}{" "}
                </div>
              </div>
            )}

            {/* N/A */}
            {resp?.notApplicable?.length !== 0 && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">N/A: </label>
                <div className="col-7 p-0 font-weight-bold">
                  {resp?.notApplicable?.map((k) => {
                    let optionValue = "";
                    notapplicableOptions?.length > 0 &&
                      notapplicableOptions.map((l) => {
                        if (k == l.key) optionValue = l.value;
                      });
                    return (
                      <div className="font-weight-bold" key={k}>
                        {optionValue}
                      </div>
                    );
                  })}{" "}
                </div>
              </div>
            )}

            {/* Instruments Used */}
            {resp?.instrumentsUsed?.length > 0 && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Instruments Used: </label>
                <span className="col-7 p-0 font-weight-bold">
                  {resp?.instrumentsUsed?.map((k) => {
                    let optionValue = "";
                    instrumentsusedOptions?.length > 0 &&
                      instrumentsusedOptions.map((l) => {
                        if (k == l.key) optionValue = l.value;
                      });
                    return (
                      <div className="font-weight-bold" key={k}>
                        {optionValue}
                      </div>
                    );
                  })}
                </span>
              </div>
            )}

            {/* Surface Area — Necrotic Skin */}
            {resp?.surfaceAreaOfNecroticSkinTissue !== "" && (
              <div className="pb-3">
                <label className="col-5 m-0">Surface Area Debrided of Necrotic Skin (cm²): </label>
                <span className="col-7 p-0 font-weight-bold">{resp?.surfaceAreaOfNecroticSkinTissue}</span>
              </div>
            )}

            {/* Surface Area — Subq Tissue */}
            {resp?.surfaceAreaOfNecroticSubqTissue !== "" && (
              <div className="pb-3">
                <label className="col-5 m-0">Surface Area Debrided of Subq Tissue (cm²): </label>
                <span className="col-7 p-0 font-weight-bold">{resp?.surfaceAreaOfNecroticSubqTissue}</span>
              </div>
            )}

            {/* Post Debridement Bleeding Amount */}
            {resp?.postDebridementBleedingAmount !== "" && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Post Debridement Bleeding Amount: </label>
                <span className="col-7 p-0 font-weight-bold">
                  {postdebridementbleedingamountOptions?.length > 0 &&
                    postdebridementbleedingamountOptions.map((e) => {
                      const optionsValue = resp?.postDebridementBleedingAmount === e.key ? e.value : "";
                      return (
                        <div className="font-weight-bold" key={e.key}>
                          {optionsValue}
                        </div>
                      );
                    })}
                </span>
              </div>
            )}

            {/* Technique Used */}
            {resp?.techniqueUsed !== "" && (
              <div className="pb-3 row pl-3">
                <label className="col-5 m-0">Technique Used: </label>
                <span className="col-7 p-0 font-weight-bold">
                  {techniqueusedOptions?.length > 0 &&
                    techniqueusedOptions.map((e) => {
                      const optionsValue = resp?.techniqueUsed === e.key ? e.value : "";
                      return (
                        <div className="font-weight-bold" key={e.key}>
                          {optionsValue}
                        </div>
                      );
                    })}
                </span>
              </div>
            )}

            {/* Stopped Bleeding */}
            {resp?.stoppedBleedingContactPressure !== "" && (
              <div className="pb-3">
                <label className="col-5 m-0">Stopped Bleeding with Contact Pressure: </label>
                <span className="col-7 p-0 font-weight-bold">{resp?.stoppedBleedingContactPressure}</span>
              </div>
            )}
          </div>
        )}

        {/* Product category */}
        {!noDataMsg && resp && Array.isArray(resp.productCategory) && resp.productCategory === 0 ? (
          <div className={style.nodata_msg}>Your Formularys doesn't have any Debridement, please contact your Medline Sales Rep</div>
        ) : (
          <div>
            {resp &&
              Array.isArray(resp.productCategory) &&
              resp.productCategory.map((e) => {
                const getVal = listOptionsresp?.productCategory?.find((x) => x.key === e.key);
                const getValOption = getVal?.options?.find((x) => x.materialNumber === e.value);
                return (
                  <div key={e.key}>
                    <div className="d-flex">
                      <div className="col-5">{getVal?.name}: </div>
                      <div className="col-6 p-0 font-weight-bold">
                        <div>{getValOption?.productFamilyDesc}</div>
                        <div>{getValOption?.materialDescription}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>

      <div>
        {signedLockedAccess(assessmentDetails?.assessmentStage) && hideButtons && (
          <button className={style.tab_edit} onClick={onEdit} disabled={isReadOnly}>
            <img src={editIcon} alt="icon" className={style.e_icon_space} />
            Edit
          </button>
        )}
      </div>
    </div>
  </div>
);
